import ApiResourceManager from '../ApiResourceManager';

class FeaturedPostsManager extends ApiResourceManager {
  get = () =>
    this.request({
      method: 'GET',
      url: '/featured-posts',
    });

  create = (data) =>
    this.request({
      method: 'POST',
      url: '/featured-posts',
      data,
    });

  update = (postId, data) =>
    this.request({
      method: 'POST',
      url: `/featured-posts/${postId}`,
      data,
    });

  delete = (id) =>
    this.request({
      method: 'DELETE',
      url: `/featured-posts/${id}`,
    });
}

export default FeaturedPostsManager;
